import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import { AppService } from '@src/suite/app.service';
import { ClipboardTypes } from '@src/suite/common/enums/clipboard-types';
import { NomWebServicesJson } from '@src/suite/common/services/nom-web-services-json';
import { VisualStateService } from '@src/suite/common/services/visual-state-service';
import { selectSupervisor } from '@src/suite/common/store/hello-results/hello-results.selectors';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { NavigationApiActions } from '@src/suite/common/store/navigation/actions/navigation.actions';
import { selectCurrentViewState } from '@src/suite/common/store/navigation/selectors/viewstate.selectors';
import { selectPlaybookListRecords } from '@src/suite/common/store/playbook/playbook.selector';
import { isSearchViewStateRecord } from '@src/suite/common/utils/viewstate-utils';

@Component({
    selector: 'st-live-secondary-cta',
    imports: [MatButtonModule, MatButtonToggleModule, MatIcon, MatListModule, MatMenuModule, MatTooltipModule],
    templateUrl: './live-secondary-cta.component.html',
    styleUrl: './live-secondary-cta.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-live-secondary-cta',
    },
})
export class LiveSecondaryCtaComponent {
    store = inject(Store);
    appService = inject(AppService);
    visualStateService = inject(VisualStateService);
    nomWebServicesJson = inject(NomWebServicesJson);
    dialog = inject(MatDialog);

    languageSettings = this.store.selectSignal(selectI18N)();
    readonly isSupervisor = this.store.selectSignal(selectSupervisor);
    readonly selectListRecords = this.store.selectSignal(selectPlaybookListRecords);

    readonly viewState = computed(() => this.store.selectSignal(selectCurrentViewState)());

    readonly saveAsViewSettingsEnabled = computed(() => {
        return !isSearchViewStateRecord(this.viewState());
    });

    readonly saveViewSettingsEnabled = computed(() => {
        if (this.viewState()?.Path?.isTeamView && !this.isSupervisor()) return false;
        return true;
    });

    saveViewState() {
        this.store.dispatch(NavigationApiActions.saveCurrentNavigationItem());
    }

    public copyToClipboard() {
        this.appService.clipboard.copy(this.selectListRecords(), ClipboardTypes.RundownView);
    }
}
